<template>
  <div class="content-preview">
    <Preview ref="preview" 
      class="article-preview"
      :content="content" 
      @inited="initedHandle" 
      @postMessage="postMessageHandle"
      v-if="info.front_type && info.front_type > 0"
    />
    <RichContent 
      :content="content" 
      v-else
    />
  </div>
</template>

<script>
import Vue from 'vue'
import {mapState} from 'vuex'
import VueTypes from 'vue-types'
import store from '../../store/index'

import utils from '../../utils'

import gkAudio from 'gkui/audio'
import VideoPlayer from '../../components/video/CommonVideo'
import EmbedTable from './widget/EmbedTable'
import Vote from '../../components/vote/Vote'
import { Preview, html2json } from '@geekbang/editor'

import RichContent from '../article/RichContent'

import 'simplebar/dist/simplebar.css'

export default {
  name: 'content-preview',
  components: {
    RichContent,
    Preview,
    gkAudio,
    VideoPlayer,
    Vote,
    EmbedTable
  },
  props: {
    info: VueTypes.object.def({})
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile']),
    content () {
      // front_type: 0: 新站上线前迁移的文章，用RichContent   1: 新编辑器的数据，直接返回   2: 需要用html2json 转成json格式数据
      let {content, front_type: frontType} = this.info
      if (!frontType) {
        return content
      }

      if (frontType === 0) {
        return content
      } else if (frontType === 2) {
        content = html2json(content)
      } else {
        content = JSON.parse(content)
      }
      return content
    }
  },
  created () {
    utils.shareWeixin({
      title: this.info.article_title,
      desc: this.info.article_subtitle || this.info.article_summary,
      imgUrl: this.info.article_cover
    })
  },
  mounted () {
    this.initOpenInTab()
  },
  beforeDestroy () {
  },
  methods: {
    login () {
      window.ga && window.ga('send', 'event', `「注册/登录」按钮`, `文章页试读`, `${this.isMobile ? 'mobile' : 'pc'}${this.$route.name}`)
      // utils.login()
      // 如果没有登录 种下 pageAction 登录成功后进入全屏状态
      // if (!this.isMobile) {
      //   utils.storage.set('pageAction', {
      //     options: {type: 'enterImmsersion'}
      //   })
      // }
      this.$login.showLogin({
        success: () => {
          return utils.refreshLoginStatus()
        }
      })
    },
    /**
     * 给所有 a 标签添加 target属性 外链 新标签页打开
     */
    initOpenInTab () {
      let tags = document.querySelector('.content-preview').querySelectorAll('a')
      tags.forEach(item => {
        item.setAttribute('target', '_blank')
      })
    },
    /**
     * @param {Tree} catalog 树结构的目录数据
     * @param {Array} sourceTree  原始的 heading 列表
     */
    getHeading (catalog, sourceTree) {
      this.$emit('heading', catalog, sourceTree)
    },
    initedHandle (previewAPI) {
      this.PreviewAPI = previewAPI

      this.initHref()
    },
    postMessageHandle (params) {
      // this.$emit('handleNode', params)
      const actionsMap = {
        componentCreate: this.createComponent,
        toastCreate: this.createToast,
        imageClick: this.handleImage,
        linkClick: this.handleLink
      }
      if (actionsMap[params.type]) {
        actionsMap[params.type].call(this, params.attrs, params.dom)
      }
    },
    /**
     * 处理编辑器拿到的标题数据，拿到offsetTop
     */
    dealHeadings () {
      this.$nextTick(() => {
        let headings = this.PreviewAPI && this.PreviewAPI.getHeadingList()

        let source = headings.map((item, index) => {
          let dom = this.$refs.preview.$el.querySelector(`[data-id=${item.id}]`)
          let top = dom.getBoundingClientRect().top
          // 187 是导航的高度
          dom.setAttribute('top', top)
          item.offsetTop = top
          item.uuid = utils.guid()
          return item
        })
        this.$emit('heading', utils.generateTree(source), headings)
      })
    },
    /**
     * 点击图片
     * @param {Object} params  编辑器返回的数据
     * @param {HTMLDOM} params.dom   返回图片dom
     * @param {String}  params.src   图片地址
     */
    handleImage (params) {
      // 如果图片有链接就不预览大图了
      if (params.href) {
        return
      }
      const previewItemList = [{
        src: params.src || '',
        w: params.dom.naturalWidth,
        h: params.dom.naturalHeight,
        el: params.dom
      }]

      this.$preview.open({
        items: previewItemList,
        index: 0
      })
    },
    /**
     * 点击链接
     * @param {Object} params  编辑器返回的数据
     */
    handleLink (params) {
    },
    /**
     * 创建toast
     */
    createToast (params) {
      this.$Message.toast({
        message: params.text
      })
    },
    /**
     * 创建组件去挂载
     */
    createComponent (attrs, el) {
      const componentsMap = {
        vote: this.mountVote,
        audio: this.mountAudio,
        video: this.mountVideo,
        table: this.mountTable
      }

      let $el = document.createElement('div')
      $el.setAttribute('data-component', attrs.type)
      el.appendChild($el)
      if (componentsMap[attrs.type]) {
        componentsMap[attrs.type].call(this, $el, attrs.data)
      }
    },
    mountVote ($el, data) {
      this.createInstance($el, Vote, {
        id: data.id - 0,
        aid: this.info.aid,
        title: this.info.article_title
      })
    },
    mountAudio ($el, data) {
      this.createInstance($el, gkAudio, {
        src: data.url
      })
    },
    mountVideo ($el, data) {
      this.createInstance($el, VideoPlayer, {
        url: data.url,
        poster: data.poster
      })
    },
    mountTable ($el, data) {
      this.createInstance($el, EmbedTable, {
        content: data.content
      })
    },
    createInstance ($el, Component, props) {
      let $Com = Vue.extend(Component)
      new $Com({
        store,
        propsData: props
      }).$mount($el)
    },

    initHref () {
      // const hrefs = this.$refs.richText.querySelectorAll('a')
      // if (hrefs.length > 0) {
      //   Array.prototype.slice.call(hrefs).forEach(href => {
      //     const src = video.lastChild.attributes.src.value
      //   })
      // }
      const ProseMirror = document.querySelector('.ProseMirror')
      const ATags = ProseMirror.querySelectorAll('a')

      for (let i = 0; i < ATags.length; i++) {
        const EachTag = ATags[i]
        const href = EachTag.href
        if (href.indexOf('google://download') > -1) {
          // EachTag.target = 'javascript:void(0)'
          // if (href.indexOf('?') > -1) href = href.split('?')[0]
          let url = utils.getQueryString(href, 'url')
          let filename = utils.getQueryString(href, 'name')
          let fileType = utils.getFileType(url)
          const flieArr = url.split('?')[0].split('.')
          const suffix = flieArr[flieArr.length - 1]

          EachTag.onclick = () => {
            // 添加下载 PDF 的逻辑
            utils.downloadfile(url, `${filename || 'GoogleFile'}.${suffix}`, fileType)
            // 添加 GA
            // window.gtag && window.gtag('event', `Google文章详情页下载统计`, {
            //   'send_to': 'UA-160408832-1',
            //   'article_id': `${Number(this.info.aid)}`,
            //   'filename': filename
            // })
            utils.GA('send', 'event', `Google文章详情页下载统计`, `${Number(this.info.aid)}`, filename)
            return false
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/_common";

.content-preview {
  position: relative;

  &.free-read {
    padding-bottom: 260px;
  }
}

</style>
